import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import { CXENSE_API_URL } from './config';

ReactDOM.render(
  <App
    apiUrl={CXENSE_API_URL[process.env.REACT_APP_API_URLS]}
  />,
  document.getElementById('cbc-as-search-root')
);



// WEBPACK FOOTER //
// ./src/index.js